import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showErrorMessage } from '~/domain/utils';
import { PermanentJobsService } from '../services';
import { IDeleteDraftJobPayload, IGetJobPostingsResult } from '../types';

export const useDeleteDraftJob = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: PermanentJobsService.deleteDraftJob,
    onMutate: async (payload: IDeleteDraftJobPayload) => {
      const { jobPostingId } = payload;

      await queryClient.cancelQueries({ queryKey: ['GET_JOB_POSTINGS'] });

      const previousData = queryClient.getQueriesData<IGetJobPostingsResult>({
        queryKey: ['GET_JOB_POSTINGS'],
      });

      queryClient.setQueriesData<IGetJobPostingsResult>(
        { queryKey: ['GET_JOB_POSTINGS'] },
        (old) => {
          if (!old) return old;

          return {
            ...old,
            data: old.data.filter((job) => job.id !== jobPostingId),
            statistics: {
              ...old.statistics,
              tabs: {
                ...old.statistics.tabs,
                draft: Math.max(0, old.statistics.tabs.draft - 1),
              },
            },
          };
        },
      );

      return { previousData };
    },
    onError: (error, _payload, context) => {
      if (context?.previousData) {
        context.previousData.forEach(([queryKey, data]) => {
          queryClient.setQueryData(queryKey, data);
        });
      }

      showErrorMessage({ error });
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['GET_JOB_POSTINGS'] });
    },
  });
};
